import classNames from 'classnames';

import { createUseThemedStyles } from '@/hooks';

const useStyles = createUseThemedStyles((theme) => ({
	avatar: ({ size }: { size: number }) => ({
		width: size,
		height: size,
		flexShrink: 0,
		overflow: 'hidden',
		borderRadius: '50%',
		backgroundColor: theme.colors.gray300,
		'& img': {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},
	}),
}));

interface AvatarProps {
	size: number;
	url?: string;
	className?: string;
}

export const Avatar = ({ size, url, className }: AvatarProps) => {
	const classes = useStyles({
		size,
	});

	return <div className={classNames(classes.avatar, className)}>{url && <img src={url} alt="" />}</div>;
};
